import { PARTNER_TYPES } from '../../partner-types';
import { Roles } from '../../roles';
import { MenuItem } from '../types';

export const customerSupportSection: MenuItem[] = [
  {
    headTitle1: 'ryd Customer Support',
    type: 'headtitle',
    requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
    requiredUserGroup: ['ryd'],
    requiredRoles: [Roles.customer_support_admin, Roles.customer_support_agent],
  },
  {
    path: '/ryd-customer-support/overview',
    icon: 'stroke-home',
    iconf: 'fill-home',
    title: 'Overview & Search',
    type: 'link',
    active: false,
    requiredUserGroup: ['ryd'],
    requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
    requiredRoles: [Roles.customer_support_admin, Roles.customer_support_agent],
  },
  {
    path: '/ryd-customer-support/user-management',
    icon: 'stroke-user',
    iconf: 'fill-user',
    title: 'User Management',
    type: 'link',
    active: false,
    requiredUserGroup: ['ryd'],
    requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
    requiredRoles: [Roles.customer_support_admin, Roles.customer_support_agent],
  },
  {
    path: '/ryd-customer-support/find-data-by-order-uuid',
    icon: 'stroke-search',
    iconf: 'fill-search',
    title: 'Find by Order UUID',
    type: 'link',
    active: false,
    requiredUserGroup: ['ryd'],
    requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
    requiredRoles: [Roles.customer_support_admin, Roles.customer_support_agent],
  },
  {
    path: '/ryd-customer-support/find-data-by-voucher-code',
    icon: 'stroke-search',
    iconf: 'fill-search',
    title: 'Find by Voucher Code',
    type: 'link',
    active: false,
    requiredUserGroup: ['ryd'],
    requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
    requiredRoles: [Roles.customer_support_admin, Roles.customer_support_agent],
  },
  {
    path: '/ryd-customer-support/deeplink-resolver',
    icon: 'stroke-deeplink',
    iconf: 'fill-deeplink',
    title: 'Deeplink Resolver',
    type: 'link',
    active: false,
    requiredUserGroup: ['ryd'],
    requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
    requiredRoles: [Roles.customer_support_admin, Roles.customer_support_agent],
  },
  {
    path: '/ryd-customer-support/customer-status-at-partner',
    icon: 'stroke-user',
    iconf: 'fill-user',
    title: 'Customer Status at Partner',
    type: 'link',
    active: false,
    requiredUserGroup: ['ryd'],
    requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
    requiredRoles: [Roles.customer_support_admin, Roles.customer_support_agent],
  },
  {
    path: '/ryd-customer-support/find-data-by-email-partial',
    icon: 'stroke-email',
    iconf: 'fill-email',
    title: 'Partial email search & bulk actions',
    type: 'link',
    active: false,
    requiredUserGroup: ['ryd'],
    requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
    requiredRoles: [Roles.customer_support_admin, Roles.customer_support_agent],
  },
  {
    path: '/ryd-customer-support/find-data-by-payment-email',
    icon: 'stroke-email',
    iconf: 'fill-email',
    title: 'Find by Payment Email',
    type: 'link',
    active: false,
    requiredUserGroup: ['ryd'],
    requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
    requiredRoles: [Roles.customer_support_admin, Roles.customer_support_agent],
  },
  {
    path: '/ryd-customer-support/find-data-by-name',
    icon: 'stroke-user',
    iconf: 'fill-user',
    title: 'Find by Name',
    type: 'link',
    active: false,
    requiredUserGroup: ['ryd'],
    requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
    requiredRoles: [Roles.customer_support_admin, Roles.customer_support_agent],
  },
  {
    path: '/ryd-customer-support/find-data-by-invoice-number',
    icon: 'stroke-search',
    iconf: 'fill-search',
    title: 'Find by Invoice Number',
    type: 'link',
    active: false,
    requiredUserGroup: ['ryd'],
    requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
    requiredRoles: [Roles.customer_support_admin, Roles.customer_support_agent],
  },
  {
    path: '/ryd-customer-support/remote-fueling',
    icon: 'stroke-others',
    iconf: 'fill-others',
    title: 'Remote Fueling',
    type: 'link',
    active: false,
    requiredUserGroup: ['ryd'],
    requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
    requiredRoles: [
      Roles.customer_support_admin,
      Roles.customer_support_agent,
      Roles.operations_admin,
    ],
  },
  {
    path: '/ryd-customer-support/suspicious-devices',
    icon: 'stroke-others',
    iconf: 'fill-others',
    title: 'Suspicious Devices',
    type: 'link',
    active: false,
    requiredUserGroup: ['ryd'],
    requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
    requiredRoles: [
      Roles.customer_support_admin,
      Roles.customer_support_agent,
      Roles.operations_admin,
    ],
  },
  {
    path: '/ryd-customer-support/gdpr-export',
    icon: 'stroke-download',
    iconf: 'fill-download',
    title: 'GDPR Export',
    type: 'link',
    active: false,
    requiredUserGroup: ['ryd'],
    requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
    requiredRoles: [Roles.gdpr_admin],
  },
  {
    path: '/ryd-customer-support/account-deletions',
    icon: 'stroke-user',
    iconf: 'fill-user',
    title: 'Account Deletions',
    type: 'link',
    active: false,
    // The record detail page (/account-deletions/:accountId) keeps this entry active.
    activePathPrefixes: ['/ryd-customer-support/account-deletions/'],
    requiredUserGroup: ['ryd'],
    requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
    requiredRoles: [Roles.gdpr_admin],
  },
];
